var _colorSelectors;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import flow from 'lodash/flow';
import partialRight from 'lodash/partialRight';
import pickBy from 'lodash/pickBy';
import reduce from 'lodash/reduce';
import upperFirst from 'lodash/upperFirst';
import { withStyles } from '@material-ui/core/styles';
import { colorBlackSelector, colorWhiteSelector, getColorErrorSelector, getColorPrimarySelector, getColorSecondarySelector, getColorSuccessSelector, getColorTextSelector, getSignalFontVariantName, isSignalFontVariant, typographySelector } from '@signal/theme';
import { TypographyBase } from './styles';
export var TYPOGRAPHY_COLORS = {
  BLACK: 'black',
  TEXT_PRIMARY: 'textPrimary',
  TEXT_SECONDARY: 'textSecondary',
  TEXT_DARK: 'textDark',
  PRIMARY: 'primary',
  PRIMARY_DARK: 'primaryDark',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  ERROR: 'error',
  INVERSE: 'inverse',
  INHERIT: 'inherit'
};
export var TYPOGRAPHY_VARIANTS = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
  SUBTITLE_1: 'subtitle1',
  SUBTITLE_2: 'subtitle2',
  BODY_1: 'body1',
  BODY_2: 'body2',
  BODY_3: 'body3',
  BODY_4: 'body4',
  CAPTION: 'caption'
};
/**
 * Boosts the specificity of the CSS selectors used for variants and colors
 * so that they are higher than the MUI ones; that way our styles are always
 * prioritized by browsers.
 */

var boostCssSpecificity = function boostCssSpecificity(style) {
  return {
    '&&': style
  };
};

var signalVariantsSelector = partialRight(pickBy, function (definition, key) {
  return isSignalFontVariant(key);
});
/**
 * Gets Signal font variants from the theme.
 */

var getFontVariants = flow(typographySelector, signalVariantsSelector);
/**
 * Defines typography colors and selectors to get their values from the theme.
 */

export var colorSelectors = (_colorSelectors = {}, _defineProperty(_colorSelectors, TYPOGRAPHY_COLORS.BLACK, colorBlackSelector), _defineProperty(_colorSelectors, TYPOGRAPHY_COLORS.TEXT_PRIMARY, getColorTextSelector('primary')), _defineProperty(_colorSelectors, TYPOGRAPHY_COLORS.TEXT_SECONDARY, getColorTextSelector('secondary')), _defineProperty(_colorSelectors, TYPOGRAPHY_COLORS.TEXT_DARK, getColorTextSelector('dark')), _defineProperty(_colorSelectors, TYPOGRAPHY_COLORS.PRIMARY, getColorPrimarySelector('main')), _defineProperty(_colorSelectors, TYPOGRAPHY_COLORS.PRIMARY_DARK, getColorPrimarySelector('dark')), _defineProperty(_colorSelectors, TYPOGRAPHY_COLORS.SECONDARY, getColorSecondarySelector('main')), _defineProperty(_colorSelectors, TYPOGRAPHY_COLORS.SUCCESS, getColorSuccessSelector('main')), _defineProperty(_colorSelectors, TYPOGRAPHY_COLORS.ERROR, getColorErrorSelector('main')), _defineProperty(_colorSelectors, TYPOGRAPHY_COLORS.INVERSE, colorWhiteSelector), _defineProperty(_colorSelectors, TYPOGRAPHY_COLORS.INHERIT, function () {
  return 'inherit';
}), _colorSelectors);
/**
 * Gets the key to use for a given color name.
 */

var getColorKey = function getColorKey(color) {
  return "color".concat(upperFirst(color));
};
/**
 * Gets Signal font colors from the theme.
 */


var getColorStyles = function getColorStyles(theme) {
  return reduce(colorSelectors, function (colorStyles, colorSelector, color) {
    return _objectSpread(_objectSpread({}, colorStyles), {}, _defineProperty({}, getColorKey(color), boostCssSpecificity({
      color: colorSelector(theme)
    })));
  }, {});
};
/**
 * Defines styles that will be passed as `classes` to Typography.
 */


var styles = function styles(theme) {
  return _objectSpread(_objectSpread({}, getFontVariants(theme)), getColorStyles(theme));
};
/**
 * This wraps the standard material ui Typography component and intercepts
 * a couple of props to allow for custom definitions of colors and variants.
 */


export var Typography = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Typography, _React$PureComponent);

  var _super = _createSuper(Typography);

  function Typography() {
    _classCallCheck(this, Typography);

    return _super.apply(this, arguments);
  }

  _createClass(Typography, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          classNameProp = _this$props.className,
          variant = _this$props.variant,
          color = _this$props.color,
          muiVariant = _this$props.muiVariant,
          muiColor = _this$props.muiColor,
          muiClasses = _this$props.muiClasses,
          componentProp = _this$props.component,
          headlineMapping = _this$props.headlineMapping,
          rest = _objectWithoutProperties(_this$props, ["classes", "className", "variant", "color", "muiVariant", "muiColor", "muiClasses", "component", "headlineMapping"]);

      var className = classnames(classes[getSignalFontVariantName(variant)], _defineProperty({}, classes[getColorKey(color)], color !== 'default'), classNameProp);
      var component = componentProp || headlineMapping[variant];
      return /*#__PURE__*/React.createElement(TypographyBase, Object.assign({
        component: component,
        className: className,
        variant: muiVariant,
        color: muiColor,
        classes: muiClasses
      }, rest));
    }
  }]);

  return Typography;
}(React.PureComponent);

_defineProperty(Typography, "propTypes", {
  /**
   * This string will be used to get the color class.
   * @default 'textPrimary'
   * @type {string}
   */
  color: PropTypes.oneOf(Object.keys(colorSelectors).concat('default')),

  /**
   * The name of the custom signal font variant to use.
   * variant is fully intercepted and never passed to muiTypography. If you want
   * to use material ui's base variants, then use the prop muiVariant.
   * This allows us to define a custom set of font types.
   * @default 'body2'
   * @type {string}
   */
  variant: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf(Object.values(TYPOGRAPHY_VARIANTS))]),

  /**
   * This prop will be passed to the wrapped MuiTypography component so that
   * its variants can be used, if necessary. It's probably uncommon, if ever,
   * that this will be used.
   * @type {string}
   */
  muiVariant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'body1', 'body2', 'caption', 'button']),

  /**
   * We are empirically mapping the variant property to a range of different
   * DOM element types. For instance, h1 to <h1>. If you wish to change
   * that mapping, you can provide your own. Alternatively, you can use the
   * component property. The default mapping is the following:
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'p',
   *   body1: 'p',
   *   body2: 'p',
   *   body3: 'p',
   *   body4: 'p',
   *   caption: 'p',
   * }
   * @type {Object}
   */
  headlineMapping: PropTypes.object
});

_defineProperty(Typography, "defaultProps", {
  color: 'textPrimary',
  variant: 'body2',
  headlineMapping: {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'p',
    body1: 'p',
    body2: 'p',
    body3: 'p',
    body4: 'p',
    caption: 'p'
  }
});

export default withStyles(styles)(Typography);